import esFlagIcon from 'public/icons/es-flag-icon.svg';
import usFlagIcon from 'public/icons/us-flag-icon.svg';

import { LanguageOption } from '@/components/locale-picker/locale-picker.types';

export const localeToDataMap = new Map([
  [
    'en',
    {
      label: 'English',
      icon: usFlagIcon
    }
  ],
  [
    'es',
    {
      label: 'Spanish',
      icon: esFlagIcon
    }
  ]
]);

export const findOptionByValue = (options: LanguageOption[], value: string) => {
  return options.find((option) => option.value === value);
};
